import Api from '@services/API'
import standard from '../config/standard'

/**
 * @typedef {Rest}
 */
export default class Rest extends Api {
  /**
   * @type {String}
   */
  static resource = ''

  /**
   * @type {String}
   */
  id = 'id'

  /**
   * @param {String} resource
   * @param {Object} options
   * @param {Object} http
   */
  constructor(resource, options = {}, http = null) {
    super(Rest.normalize(Rest.base, resource), options, http)
  }

  /**
   * @return {this}
   */
  static build() {
    return new this(this.resource)
  }

  /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  create(record, id = null, overRoute) {
    standard.defaults.responseType = 'json'
    if (!id) {
      return this.post(`${overRoute || ''}`, record)
    } else {
      return this.post(`/${id}`, record)
    }
  }
  blob(record) {
    standard.defaults.responseType = 'blob'
    return this.post('', record)
  }

  downloadBlob(record) {
    return this.postBlob('', record)
  }

  blob2(record, id = null) {
    standard.defaults.responseType = 'blob'
    if (!id) {
      return this.post('', record)
    } else {
      return this.post(`/${id}`, record)
    }
  }

  /**
   * @param {String|Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  read(record) {
    standard.defaults.responseType = 'json'
    return this.get(`/${this.getId(record)}`)
  }

  /**
   * @param {String|Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  readSubEndpoints(finalUrl) {
    standard.defaults.responseType = 'json'
    return this.get(finalUrl)
  }

  /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  update(record, id = null) {
    standard.defaults.responseType = 'json'
    if (!id) {
      return this.put(`/${this.getId(record)}`, record)
    } else {
      return this.put(`/${id}`, record)
    }
  }

  /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  destroy(record) {
    standard.defaults.responseType = 'json'
    return this.delete(`/${this.getId(record)}`)
  }

  /**
   * @param {Object} parameters
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  search(parameters = {}) {
    standard.defaults.responseType = 'json'
    let url = ''
    if (typeof parameters['url'] !== 'undefined') {
      url = parameters['url']
      delete parameters['url']
    }

    const queryString = Object.keys(parameters)
      .map((key) => {
        if (Array.isArray(parameters[key])) {
          return key + '[]' + '=' + parameters[key].join(`&${key}[]=`)
        } else {
          return key + '=' + parameters[key]
        }
      })
      .join('&')

    if (Object.keys(parameters).length) return this.get(`${url}?${queryString}`)

    return this.get(url)
  }

  /**
   * @param {String|Object} record
   * @returns {String}
   */
  getId(record) {
    standard.defaults.responseType = 'json'
    if (typeof record === 'object') {
      return record[this.id]
    }
    return String(record)
  }
}
